import * as React from "react";
const SvgTextClipIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 20V4H6V20H4ZM18 20V13H8V11H18V4H20V20H18Z", fill: "currentColor" }));
export default SvgTextClipIcon;
